import classNames from "classnames"
import type React from "react"
import { Icon, type IconSources } from "../Icon"
import { withFieldLabelAndHint } from "./field"
import type { FormElement } from "./form"

type Props = {
  type?: "checkbox" | "radio"
  icon?: IconSources
  value: string
  children: React.ReactNode
  defaultChecked?: boolean
  name: string
} & FormElement &
  React.InputHTMLAttributes<HTMLInputElement>

const CheckablePill = ({
  type,
  icon,
  value,
  children,
  defaultChecked,
  status,
  ...InputProps
}: Props) => {
  return (
    <span
      className={classNames("cobalt-CheckablePillField", {
        "cobalt-CheckablePillField--error": status === "error",
        "cobalt-CheckablePillField--with-icon": icon,
      })}
    >
      <label className="cobalt-CheckablePillField__LabelWrapper">
        <input
          {...InputProps}
          type={type}
          className="cobalt-CheckablePillField__Input"
          value={value}
          defaultChecked={defaultChecked}
        />
        <span className="cobalt-CheckablePillField__Label">
          {icon && <Icon source={icon} />}
          {children}
        </span>
      </label>
    </span>
  )
}

export const CheckboxPill = ({ ...props }: Props) => {
  return <CheckablePill {...props} type="checkbox" />
}
CheckboxPill.displayName = "CheckboxPill"

export const RadioPill = ({ ...props }: Props) => {
  return <CheckablePill {...props} type="radio" />
}
RadioPill.displayName = "RadioPill"

interface CheckablePillsGroupProps {
  children: React.ReactNode | (() => React.ReactNode)
}

const _CheckablePillsGroup = ({ children }: CheckablePillsGroupProps) => {
  return (
    <div className="cobalt-CheckablePillsGroup">
      {typeof children === "function" ? children() : children}
    </div>
  )
}

export const CheckablePillsGroup = withFieldLabelAndHint(_CheckablePillsGroup)
CheckablePillsGroup.displayName = "CheckablePillsGroup"
